"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMinuteTwoDigit = exports.getMinuteNumeric = void 0;
var pad_number_to_length_1 = require("../utils/pad-number-to-length");
/**
 * Returns a numerical representation of the minute: 0, 1, ..., 59
 * @hidden
 */
var getMinuteNumeric = function (_a) {
    var offsetUtcDate = _a.offsetUtcDate;
    return offsetUtcDate.getUTCMinutes();
};
exports.getMinuteNumeric = getMinuteNumeric;
/**
 * Returns a two-digit string representation of the minute: 00, 01, ..., 59
 * @hidden
 */
var getMinuteTwoDigit = function (params) {
    var minutes = exports.getMinuteNumeric(params);
    return pad_number_to_length_1.padNumberToLength(minutes, 2);
};
exports.getMinuteTwoDigit = getMinuteTwoDigit;
//# sourceMappingURL=minute.js.map